import Commandbar from "~/components/planning/Commandbar"
import { RemoveVariantsFromPurchasePlanDialog } from "~/components/purchase-plan/RemoveVariantsFromPurchasePlanDialog"
import MultiEditDialog from "~/components/planning/MultiEditDialog/MultiEditDialog"
import { EditSkuTagsDialog } from "~/components/planning/Tags/EditSkuTagsDialog"
import { useVariantsByIds } from "~/hooks/useVariants"
import { getCommonVendors } from "~/utils/vendorUtils"

type MultiEditVariantPurchasePlanPanelProps = {
  selectedVariantIds: string[]
  selectedVariantCount: number
  clearSelectedIds: () => void
}

export function MultiEditVariantPurchasePlanPanel({
  selectedVariantIds,
  selectedVariantCount,
  clearSelectedIds,
}: MultiEditVariantPurchasePlanPanelProps) {
  const variants = useVariantsByIds(selectedVariantIds)
  const skuIds = variants.flatMap((v) => v.skuIds)
  const commonVendors = getCommonVendors(variants)

  return (
    <>
      {selectedVariantCount > 0 && (
        <Commandbar count={selectedVariantCount} onClear={clearSelectedIds}>
          <MultiEditDialog
            selectedSkuIds={skuIds}
            selectedVariantCount={selectedVariantCount}
            resetSelectedProductIds={clearSelectedIds}
            commonVendors={commonVendors}
          />
          <EditSkuTagsDialog variantIds={selectedVariantIds} />
          <RemoveVariantsFromPurchasePlanDialog variantIds={selectedVariantIds} />
        </Commandbar>
      )}
    </>
  )
}
